













import { Component, Vue } from 'vue-property-decorator'
import RessortTitle from '~components/content/widgets/listings/RessortTitle.vue'
import DropDown from '~components/utils/DropDown.vue'
import { townships as places } from '~base/store/weather'

@Component({
  components: {
    RessortTitle,
    DropDown,
  },
})
export default class GrundUndBoden extends Vue {
  private township = 'Vorarlberg'

  get localityList() {
    const localities = places.map((a) => a[0])
    return ['Vorarlberg', ...localities]
  }

  onChange(e: string) {
    this.township = e
    const slugs = places.find((t) => t[0] === e || t[1] === e)
    if (slugs) this.$emit('on-title-action', { localities: [slugs[1]] })
    else {
      this.$emit('on-title-action', {})
    }
  }
}
